import {memo} from "react";

interface PProps {
    children: JSX.Element | string | number | JSX.Element[],
    block?: boolean
}

const P = ({children, block = true}: PProps) => {

    return <span
        className={`text-blue-gray-900 dark:text-white antialiased font-sans text-sm font-normal leading-none opacity-70 ${block?'block': ''}`}>{children}</span>;
}

export default memo(P);
